export enum signupEvents {
  directRegistration = "direct_registration",
}

export const pushEvent = (eventName?: string, parameters = {}) => {
  if (eventName) {
    (window as any)?.dataLayer?.push({
      event: eventName,
      ...parameters,
    });
  }
};
